import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SettingsIcon from '@mui/icons-material/Settings';

export const buttonsAvailable: any = {
  home: {
    label: 'Inicio',
    id: 'home',
    icon: <HomeIcon style={{ fontSize: '19px' }} />,
  },
  factoring: {
    label: 'Factoring',
    id: 'factoring',
    icon: <ReceiptIcon style={{ fontSize: '19px' }} />,
  },
  sgr: {
    label: 'SGR',
    id: 'sgr',
    icon: <CardMembershipIcon style={{ fontSize: '19px' }} />,
  },
  credit: {
    label: 'Crédito',
    id: 'credit',
    icon: <CreditCardIcon style={{ fontSize: '19px' }} />,
  },
  settings: {
    label: 'Configuración',
    id: 'settings',
    icon: <SettingsIcon style={{ fontSize: '19px' }} />,
  },
};
